import { render, staticRenderFns } from "./RetrieveEmailCampaigns.vue?vue&type=template&id=5bffaf5a&"
import script from "./RetrieveEmailCampaigns.vue?vue&type=script&lang=ts&"
export * from "./RetrieveEmailCampaigns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports